import i18n from "i18next";
import nookies from "nookies";
import { initReactI18next } from "react-i18next";
import urljoin from "url-join";

import { navigateTo } from "components/store/source";

// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
// We allow passing lng so that server-side rendering can override LanguageDetector
// which doesn't work correctly on the server.
export const init = (lng = global.locale, resources = global.translations) => {
  i18n.use(initReactI18next).init({
    defaultNS: "common",
    fallbackLng: {
      default: ["en-US"],
    },
    lng,
    ns: "common",
    react: { useSuspense: false },
    resources,

    // React already safes from xss
    // https://react.i18next.com/getting-started
    // https://www.i18next.com/translation-function/interpolation#unescape
    interpolation: {
      escapeValue: false,
    },
  });
};

init();

const changeLocale = locale => {
  if (locale === i18n.language) return;

  let pathname = global.location.pathname;
  const prefix = urljoin("/", i18n.language.toLowerCase());
  // this to switch from /fr to /. the navigateTo will add the new language prefix
  if (pathname.startsWith(prefix)) {
    pathname = pathname.slice(prefix.length);
  }

  nookies.set(null, "NEXT_LOCALE", locale, { path: "/" });

  i18n.language = locale;

  // navigate to the current page in the other language
  navigateTo(pathname + global.location.hash + global.location.search);
};

const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
  { value: "es", label: "Español" },
  { value: "it", label: "Italiano" },
  //{ value: "ar", label: "عربى" }, // Temporarily disable ar
];

const LANGUAGES2 = [
  { value: "en-US", label: "English", flag: "us", currency: "USD" },
  { value: "en-CA", label: "English", flag: "ca", currency: "CAD" },
  { value: "en-GB", label: "English", flag: "gb", currency: "GBP" },
  { value: "fr-FR", label: "Français", flag: "fr", currency: "EUR" },
  { value: "fr-CA", label: "Français", flag: "ca", currency: "CAD" },
  { value: "es-ES", label: "Español", flag: "es", currency: "EUR" },
  { value: "es-MX", label: "Español", flag: "mx", currency: "MXN" },
  { value: "it-IT", label: "Italiano", flag: "it", currency: "EUR" },
];

const CURRENCIES = [
  { code: "USD", label: "US Dollars", sign: "$" },
  { code: "CAD", label: "Canadian Dollars", sign: "$" },
  { code: "EUR", label: "Euro", sign: "€" },
  { code: "GBP", label: "British Pound", sign: "£" },
  { code: "AED", label: "UAE Dirham", sign: "د.إ" },
  { code: "MXN", label: "Mexican Peso", sign: "$" },
];

export { LANGUAGES, LANGUAGES2, CURRENCIES, changeLocale };

export * from "next-i18next";

export default i18n;
